import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'Id', label: '实物号码', width: null },
  { prop: 'SizeX', label: '长(CM)', width: null },
  { prop: 'SizeY', label: '宽(CM)', width: null },
  { prop: 'SizeZ', label: '高(CM)', width: null },
  { prop: 'DimensionalWeight', label: '体积重(KG)', width: null },
  { prop: 'ScanTime', label: '扫描时间', width: null },
  { prop: 'state', label: '状态', width: null },
  { prop: 'Info', label: '提示/警告信息', width: null },
];
export default { tableHeader }
